import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout")({
    component: () => <ToolLayout />,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.title"),
        };
    },
});

function ToolLayout() {
    return <Outlet />;
}
